// --------------------------------------------------------------------------
// Components of EOx page including their logical connections.
// --------------------------------------------------------------------------

import { Flex } from '@chakra-ui/react';
import HeaderEOx from './components/HeaderEOx';
import BodyEOx from './components/BodyEOx';


const EOxPage: React.FC = () => {
  return(
    <Flex flexDirection="column" height="100vh">
      <HeaderEOx />
      <BodyEOx />
    </Flex>
  );
};

export default EOxPage;